import React, { useEffect, useRef, useState } from 'react';
import Header from '~/Components/Header';
import { Formik, Field, FastField } from 'formik';
import { Form, Button, Row, Col, Table, Modal, Card } from 'react-bootstrap';
import {
  FaFileUpload,
  FaCloudUploadAlt,
  FaEraser,
  FaTrash,
  FaExclamationTriangle,
  FaBuilding,
  FaMoneyBillWave,
  FaFileAlt,
  FaCalendarAlt,
  FaUserTie,
  FaClipboardList,
  FaFolderOpen,
} from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import { toast } from 'react-toastify';
import api from '~/Services/api';
import { default as Selector } from 'react-select';
import DateMask from '~/Utils/DateMask';
import { MASK_DATE, MASK_MES_ANO, tipoBooleano, TIPOS_CONTA } from '~/constants';
import MoneyField from '~/Components/MoneyField/MoneyField';
import { formatarMonetario } from '~/Utils/Helpers';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { customStyles, DropdownIndicator } from '~/Styles/react-select-styles';
import { TIPOS_SOLICITACAO } from '~/constants';

const tipoSolicitacaoOptions = [
  { value: 'Vazio', label: 'Selecione...' },
  { value: TIPOS_SOLICITACAO.Despesa, label: 'Despesa' },
  { value: TIPOS_SOLICITACAO.Projeto, label: 'Projeto' },
  { value: TIPOS_SOLICITACAO.Comissao, label: 'Comissão' },
  { value: TIPOS_SOLICITACAO.DespesaCartaoCredito, label: 'Despesa Cartão de Crédito' },
];

const temRateioOptions = [
  { value: '', label: 'Selecione...' },
  { value: '1', label: 'Sim' },
  { value: '0', label: 'Não' },
];

const sectionStyles = {
  card: {
    marginBottom: '1.25rem',
    border: '1px solid #e3e6f0',
    borderRadius: '0.5rem',
    boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
  },
  cardHeader: {
    backgroundColor: '#f8f9fc',
    borderBottom: '1px solid #e3e6f0',
    padding: '0.75rem 1.25rem',
    fontWeight: '600',
    fontSize: '0.95rem',
    color: '#5a5c69',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  cardBody: {
    padding: '1.25rem',
  },
  formLabel: {
    fontWeight: '500',
    fontSize: '0.85rem',
    color: '#5a5c69',
    marginBottom: '0.375rem',
  },
};

export default function TransmissaoDocs({ solicitacao }) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const [solicitacaoQueryString, setSolicitacaoQueryString] = useState(() => {
    const valorParam = params.get('solicitacao');
    if (!valorParam) return null;
    try {
      return JSON.parse(decodeURIComponent(atob(valorParam)));
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(valorParam));
      } catch (fallbackError) {
        console.error(
          'Erro ao decodificar parâmetro solicitacao:',
          fallbackError
        );
        return null;
      }
    }
  });

  useEffect(() => {
    const valorParam = params.get('solicitacao');
    let objeto = null;
    if (valorParam) {
      try {
        objeto = JSON.parse(decodeURIComponent(atob(valorParam)));
      } catch (error) {
        try {
          objeto = JSON.parse(decodeURIComponent(valorParam));
        } catch (fallbackError) {
          console.error(
            'Erro ao decodificar parâmetro solicitacao:',
            fallbackError
          );
          objeto = null;
        }
      }
    }
    setSolicitacaoQueryString(objeto);
  }, []);

  const [arquivosParaEnvio, setArquivosParaEnvio] = useState([]);
  const arquivoRef = React.createRef();
  const [tipoDespesaSelecionado, setTipoDespesaSelecionado] = useState(false);
  const [tipoProjetoSelecionado, setTipoProjetoSelecionado] = useState(false);
  const [tipoComissaoSelecionado, setTipoComissaoSelecionado] = useState(false);
  const [
    tipoDespesaCartaoCreditoSelecionado,
    setTipoDespesaCartaoCreditoSelecionado,
  ] = useState(false);

  const [gesOptions, setGesOptions] = useState([]);
  const [fornecedoresOptions, setFornecedoresOptions] = useState([]);
  const [tiposPagamentoOptions, setTiposPagamentoOptions] = useState([]);
  const [tiposDocOptions, setTipoDocOptions] = useState([]);
  const [departamentosOptions, setDepartamentosOptions] = useState([]);
  const [despesaReceitaOptions, setDespesaReceitaOptions] = useState([]);
  const [contasInternasOptions, setContasInternasOptions] = useState([]);
  const [centroDeCustoOptions, setCentroDeCustoOptions] = useState([]);
  const [cartoesOptions, setCartoesOptions] = useState([]);
  const [fornecedoresTipoProjetoOptions, setFornecedoresTipoProjetoOptions] =
    useState([]);
  const fornecedoresPorGeRef = useRef({});
  const [salvandoSolicitacao, setSalvandoSolicitacao] = useState(false);
  const [
    mostrarModalDepartamentoInvalido,
    setMostrarModalDepartamentoInvalido,
  ] = useState(false);
  const [mostrarModalContaInvalida, setMostrarModalContaInvalida] =
    useState(false);
  const [mostrarModalRateioInvalido, setMostrarModalRateioInvalido] =
    useState(false);
  const [limparFormik, setLimparFormik] = useState(Date.now());
  const [tipoDocumentoSelecionado, setTipoDocumentoSelecionado] =
    useState(null);
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  const documentosNotaFiscal = {
    NotaFiscal: 3,
    NFSProdutorRural: 7,
    NFSMei: 10,
  };

  const limparFormulario = () => {
    setLimparFormik(Date.now());
    setTipoProjetoSelecionado(false);
    setTipoDespesaSelecionado(false);
    setTipoComissaoSelecionado(false);
    setTipoDespesaCartaoCreditoSelecionado(false);
    setArquivosParaEnvio([]);
    limparOptions();
    setTipoDocumentoSelecionado(null);
  };

  const limparOptions = () => {
    setFornecedoresOptions([]);
    setTiposPagamentoOptions([]);
    setTipoDocOptions([]);
    setDespesaReceitaOptions([]);
    setCentroDeCustoOptions([]);
    setContasInternasOptions([]);
    setFornecedoresTipoProjetoOptions([]);
    setCartoesOptions([]);
  };

  const verificarTipoFormulario = value => {
    if (value) {
      switch (value) {
        case TIPOS_SOLICITACAO.Despesa:
          setTipoDespesaSelecionado(true);
          setTipoProjetoSelecionado(false);
          setTipoComissaoSelecionado(false);
          setTipoDespesaCartaoCreditoSelecionado(false);
          break;
        case TIPOS_SOLICITACAO.Projeto:
          setTipoProjetoSelecionado(true);
          setTipoDespesaSelecionado(false);
          setTipoComissaoSelecionado(false);
          setTipoDespesaCartaoCreditoSelecionado(false);
          break;
        case TIPOS_SOLICITACAO.Comissao:
          setTipoComissaoSelecionado(true);
          setTipoDespesaSelecionado(false);
          setTipoProjetoSelecionado(false);
          setTipoDespesaCartaoCreditoSelecionado(false);
          break;
        case TIPOS_SOLICITACAO.DespesaCartaoCredito:
          // Herda o comportamento de Despesa (contas, fornecedor, departamento, rateio).
          setTipoDespesaSelecionado(true);
          setTipoProjetoSelecionado(false);
          setTipoComissaoSelecionado(false);
          setTipoDespesaCartaoCreditoSelecionado(true);
          break;
        default:
          return;
      }
    }
  };

  const obterGesValidos = async () => {
    try {
      const response = await api.buscarGesValidos();
      if (response) {
        setGesOptions(
          [
            { value: '', label: 'Selecione...' },
            ...response.map(ge => ({
              value: ge.codigo,
              label: `${ge.codigo} - ${ge.descricao}`,
              tem_parceria: ge.tem_parceria,
            })),
          ].sort()
        );
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const obterFiltrosRestantes = async (tipo, ge) => {
    try {
      limparOptions();
      const response = await api.buscarFiltrosRestantes({
        codigo_despesa_projeto_tipo_solicitacao: tipo,
        ge: ge,
      });

      if (response) {
        setTiposPagamentoOptions([
          { value: '', label: 'Selecione...' },
          ...response.tipos_pagamento.map(pagto => ({
            value: pagto.codigo,
            label: `${pagto.codigo} - ${pagto.descricao}`,
          })),
        ]);
        setTipoDocOptions([
          { value: '', label: 'Selecione...' },
          ...response.tipos_documento.map(doc => ({
            value: doc.codigo,
            label: `${doc.codigo} - ${doc.descricao}`,
          })),
        ]);

        setDespesaReceitaOptions([
          { value: '', label: 'Selecione...' },
          ...response.contas_despesa_receita.map(conta => ({
            value: conta.codigo,
            label: `${conta.codigo} - ${conta.descricao}`,
            conta_permitida_para_parceria: conta.conta_permitida_para_parceria,
            tipo: conta.tipo,
          })),
        ]);
        setContasInternasOptions([
          { value: '', label: 'Selecione...' },
          ...response.contas_internas.map(contaInterna => ({
            value: contaInterna.codigo,
            label: `${contaInterna.codigo} - ${contaInterna.descricao}`,
            conta_despesa: contaInterna.conta_despesa,
          })),
        ]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const obterDepartamentos = async () => {
    try {
      const response = await api.buscarDepartamentos();
      if (response) {
        setDepartamentosOptions([
          { value: '', label: 'Selecione...' },
          ...response.map(dep => ({
            value: dep.codigo,
            label: `${dep.codigo} - ${dep.descricao}`,
            tem_ge_vinculado: dep.tem_ge_vinculado,
          })),
        ]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const obterFornecedores = async (ge, tipoSolicitacao) => {
    try {
      const chaveCache = `${ge}-${tipoSolicitacao}`;
      let response = fornecedoresPorGeRef.current[chaveCache];

      if (!response) {
        response = await api.obterFiltrosFornecedores(ge, tipoSolicitacao);
        fornecedoresPorGeRef.current[chaveCache] = response;
      }

      if (tipoSolicitacao === TIPOS_SOLICITACAO.Projeto) {
        setFornecedoresTipoProjetoOptions([
          { value: '', label: 'Selecione...' },
          ...(response.fornecedores_tipo_projeto || []).map(fornecedor => ({
            value: fornecedor.codigo,
            label: `${fornecedor.codigo} - ${fornecedor.descricao}`,
          })),
        ]);
      } else {
        setFornecedoresOptions([
          { value: '', label: 'Selecione...' },
          ...(response.fornecedores || []).map(fornecedor => ({
            value: fornecedor.codigo,
            label: `${fornecedor.codigo} - ${fornecedor.descricao}`,
          })),
        ]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const obterFiltroCentralDeCustos = async (ge, codigo_conta) => {
    try {
      const response = await api.buscarFiltroCentroDeCusto(ge, codigo_conta);
      if (response) {
        setCentroDeCustoOptions([
          { value: '', label: 'Selecione...' },
          ...response.centro_de_custo.map(item => ({
            value: item.codigo,
            label: `${item.codigo} - ${item.descricao}`,
          })),
        ]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const obterCartoesAtivos = async ge => {
    try {
      setCartoesOptions([]);
      const response = await api.buscarCartoesAtivos(ge);
      if (response) {
        setCartoesOptions([
          { value: '', label: 'Selecione...' },
          ...response.map(cartao => ({
            value: cartao.codigo,
            label: cartao.descricao,
          })),
        ]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const adicionarArquivos = e => {
    const arquivos = Array.from(e.target.files);
    setArquivosParaEnvio(digitalizacoes => [...digitalizacoes, ...arquivos]);
  };

  const finalizarSolicitacao = async request => {
    try {
      setSalvandoSolicitacao(true);
      const formData = new FormData();
      const arquivosExistentes = arquivosParaEnvio.filter(
        arquivo => !(arquivo instanceof File)
      );
      const novosArquivos = arquivosParaEnvio.filter(
        arquivo => arquivo instanceof File
      );

      if (
        request.codigo_despesa_projeto_tipo_solicitacao ===
        TIPOS_SOLICITACAO.DespesaCartaoCredito
      ) {
        request = {
          ...request,
          tipo_pagamento: null,
          mes_fatura: normalizarMesFatura(request.mes_fatura),
        };
      } else {
        request = {
          ...request,
          codigo_cartao: null,
          mes_fatura: null,
        };
      }

      if (solicitacao) {
        request = {
          ...request,
          CodigoUsuario: solicitacao.codigo_usuario,
          Codigo: solicitacao.codigo_solicitacao,
          arquivos_existentes: arquivosExistentes.map(arquivo => ({
            NomeArquivo: arquivo.name,
            CodigoUpload: arquivo.codigo_upload,
            StatusDigitalizacao: arquivo.status_digitalizacao,
          })),
        };
      }

      formData.append('request', JSON.stringify(request));
      novosArquivos.forEach(arquivo => {
        formData.append(arquivo.name, arquivo);
      });

      let response;
      if (solicitacao) {
        response = await api.AtualizarSolicitacaoDespesaProjeto(formData);
      } else {
        response = await api.salvarDados(formData);
      }
      if (response) {
        toast.success(response.message);
        limparFormulario();
        if (solicitacao) {
          await sleep(2500);
        }
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      if (solicitacao) {
        window.location.reload();
      }
      setSalvandoSolicitacao(false);
    }
  };

  const removerDigitalizacao = arquivoExclusao => {
    setArquivosParaEnvio(
      arquivosParaEnvio.filter(arquivo => arquivo.name !== arquivoExclusao.name)
    );
  };

  const habilitarCampoDataNF = documentoSelecionado => {
    return (
      documentoSelecionado === documentosNotaFiscal.NFSMei ||
      documentoSelecionado === documentosNotaFiscal.NFSProdutorRural ||
      documentoSelecionado === documentosNotaFiscal.NotaFiscal
    );
  };

  // Converte a data recebida do backend (Mes_Fatura normalizado no dia 1) para o
  // formato de exibição/edição MM/AAAA usado pela máscara do campo Mês Fatura.
  const formatarMesFatura = mesFatura => {
    if (!mesFatura) return '';
    const data = new Date(mesFatura);
    if (isNaN(data.getTime())) return '';
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
    const ano = data.getUTCFullYear();
    return `${mes}/${ano}`;
  };

  // Normaliza o valor digitado (MM/AAAA) para uma data no primeiro dia do mês,
  // no mesmo padrão adotado pelo Delphi (StrToDate('01/' + MM/AAAA)).
  const normalizarMesFatura = mesFatura => {
    const match = /^(\d{2})\/(\d{4})$/.exec(mesFatura || '');
    if (!match) return null;
    const mes = match[1];
    const ano = match[2];
    return `${ano}-${mes}-01`;
  };


  useEffect(() => {
    obterGesValidos();
    obterDepartamentos();
    if (solicitacao) {
      verificarTipoFormulario(
        solicitacao.codigo_despesa_projeto_tipo_solicitacao
      );
      setTipoDocumentoSelecionado(solicitacao.tipo_documento);
      if (solicitacao.digitalizacoes && solicitacao.digitalizacoes.length > 0) {
        const arquivos = solicitacao.digitalizacoes.map(digitalizacao => ({
          name: digitalizacao.nome_arquivo,
          codigo_upload: digitalizacao.codigo_upload,
          status_digitalizacao: digitalizacao.status_digitalizacao,
        }));
        setArquivosParaEnvio(arquivos);
      }
      if (solicitacao.ge) {
        obterFiltrosRestantes(
          solicitacao.codigo_despesa_projeto_tipo_solicitacao,
          solicitacao.ge
        );
        obterFornecedores(
          solicitacao.ge,
          solicitacao.codigo_despesa_projeto_tipo_solicitacao
        );
        if (
          solicitacao.codigo_despesa_projeto_tipo_solicitacao ===
          TIPOS_SOLICITACAO.DespesaCartaoCredito
        ) {
          obterCartoesAtivos(solicitacao.ge);
        }
      }
      if (solicitacao.codigo_conta_interna) {
        obterFiltroCentralDeCustos(
          solicitacao.ge,
          solicitacao.codigo_conta_interna
        );
      }
    } else if (solicitacaoQueryString) {
      verificarTipoFormulario(
        solicitacaoQueryString.codigo_despesa_projeto_tipo_solicitacao
      );
      setTipoDocumentoSelecionado(solicitacaoQueryString.tipo_documento);
      if (solicitacaoQueryString.ge) {
        obterFiltrosRestantes(
          solicitacaoQueryString.codigo_despesa_projeto_tipo_solicitacao,
          solicitacaoQueryString.ge
        );
        obterFornecedores(
          solicitacaoQueryString.ge,
          solicitacaoQueryString.codigo_despesa_projeto_tipo_solicitacao
        );
        if (
          solicitacaoQueryString.codigo_despesa_projeto_tipo_solicitacao ===
          TIPOS_SOLICITACAO.DespesaCartaoCredito
        ) {
          obterCartoesAtivos(solicitacaoQueryString.ge);
        }
      }
      if (solicitacaoQueryString.codigo_conta_interna) {
        obterFiltroCentralDeCustos(
          solicitacaoQueryString.ge,
          solicitacaoQueryString.codigo_conta_interna
        );
      }
      setLimparFormik(Date.now());
    }
  }, [solicitacao, solicitacaoQueryString]);

  const departamentoValido = (ge, departamentoEscolhido, tipoSolicitacao) => {
    if (
      gesOptions.find(geItem => geItem.value === ge).tem_parceria ===
      tipoBooleano.Sim &&
      tipoSolicitacao !== TIPOS_SOLICITACAO.Comissao &&
      tipoSolicitacao !== TIPOS_SOLICITACAO.Projeto
    ) {
      if (
        departamentosOptions.find(dep => dep.value === departamentoEscolhido)
          .tem_ge_vinculado === tipoBooleano.Sim
      ) {
        setMostrarModalDepartamentoInvalido(true);
        return false;
      }
    }
    setMostrarModalDepartamentoInvalido(false);
    return true;
  };

  const despesaValida = (ge, contaEscolhida, tipoConta) => {
    if (
      tipoConta === TIPOS_CONTA.Despesa ||
      tipoConta === TIPOS_CONTA.Receita
    ) {
      if (
        gesOptions.find(geItem => geItem.value === ge).tem_parceria ===
        tipoBooleano.Sim
      ) {
        if (
          despesaReceitaOptions.find(
            ContaDesp => ContaDesp.value === contaEscolhida
          ).conta_permitida_para_parceria === tipoBooleano.Nao
        ) {
          setMostrarModalContaInvalida(true);
          return false;
        }
      }
    }

    setMostrarModalContaInvalida(false);
    return true;
  };

  const rateioValido = (ge, temRateio) => {
    if (
      gesOptions.find(geItem => geItem.value === ge).tem_parceria ===
      tipoBooleano.Sim
    ) {
      if (temRateio == tipoBooleano.Sim) {
        setMostrarModalRateioInvalido(true);
        return false;
      }
    }

    setMostrarModalRateioInvalido(false);
    return true;
  };

  const contaProjetoValida = (ge, contaEscolhida, departamento) => {
    const geTemParceria = gesOptions.find(geItem => geItem.value === ge)?.tem_parceria === tipoBooleano.Sim;

    if (!geTemParceria) {
      setMostrarModalDepartamentoInvalido(false);
      return true;
    }

    const depTemGEVinculado = departamentosOptions.find(dep => dep.value === departamento)?.tem_ge_vinculado === tipoBooleano.Sim;

    if (!depTemGEVinculado) {
      setMostrarModalDepartamentoInvalido(false);
      return true;
    }

    const contaSelecionada = contasInternasOptions.find(conta => conta.value === contaEscolhida);
    const ehContaDespesa = contaSelecionada?.conta_despesa === tipoBooleano.Sim;

    if (ehContaDespesa) {
      setMostrarModalDepartamentoInvalido(true);
      return false;
    }

    setMostrarModalDepartamentoInvalido(false);
    return true;
  };

  return (
    <div style={{ backgroundColor: '#f4f6f9', minHeight: '100vh' }}>
      <Header
        title={
          solicitacao ? 'Editar Solicitação' : 'Solicitação despesa/projeto'
        }
      />
      <Formik
        enableReinitialize={solicitacao || solicitacaoQueryString}
        validationSchema={Yup.object().shape({
          codigo_despesa_projeto_tipo_solicitacao:
            Yup.string().required('*Informe o tipo'),
          ge: Yup.string().required('*Informe o GE'),
          departamento: Yup.string().required('*Informe o departamento'),
          valor: Yup.number()
            .required('*Informe o valor')
            .moreThan(0, '*O valor deve ser maior que zero'),
          tipo_documento: Yup.string().required('*Informe o tipo do documento'),
          ...(!tipoDespesaCartaoCreditoSelecionado && {
            tipo_pagamento: Yup.string().required(
              '*Informe o tipo de pagamento'
            ),
          }),
          data_vencimento: Yup.date().required(
            tipoDespesaCartaoCreditoSelecionado
              ? '*Informe a data da compra'
              : '*Informe a data de vencimento'
          ),
          data_entrada: Yup.date().required('*Informe a data de entrada'),
          numero_documento: Yup.string().required(
            '*Informe o número do documento'
          ),
          ...((tipoComissaoSelecionado || tipoDespesaSelecionado) && {
            codigo_despesa_receita: Yup.string().required(
              tipoDespesaSelecionado
                ? '*Informe o código de despesa/receita'
                : '*Informe o código de conta corretor'
            ),
          }),
          ...(tipoProjetoSelecionado && {
            codigo_conta: Yup.string().required('*Informe uma conta'),
            codigo_centro_de_custo: Yup.string().required(
              '*Informe um centro de custo'
            ),
          }),
          ...(tipoDespesaCartaoCreditoSelecionado && {
            codigo_cartao: Yup.string().required('*Informe o cartão'),
            mes_fatura: Yup.string()
              .required('*Informe o mês da fatura')
              .test('mes-valido', '*Mês inválido', value => {
                if (!value) return false;
                const match = /^(\d{2})\/(\d{4})$/.exec(value);
                if (!match) return false;
                const mes = Number(match[1]);
                return mes >= 1 && mes <= 12;
              }),
          }),
        })}
        initialValues={
          solicitacao
            ? {
              ge: solicitacao.ge,
              codigo_despesa_projeto_tipo_solicitacao:
                solicitacao.codigo_despesa_projeto_tipo_solicitacao,
              departamento: solicitacao.codigo_departamento,
              tipo_documento: solicitacao.codigo_tipo_documento,
              valor: solicitacao.valor,
              tipo_pagamento: solicitacao.codigo_tipo_pagamento,
              codigo_fornecedor:
                solicitacao.codigo_fornecedor === 0
                  ? ''
                  : solicitacao.codigo_fornecedor,
              tem_rateio: solicitacao.tem_rateio,
              data_vencimento: solicitacao.data_vencimento,
              data_entrada: solicitacao.data_entrada,
              numero_documento: solicitacao.numero_documento || '',
              codigo_despesa_receita:
                solicitacao.codigo_despesa_receita === 0
                  ? ''
                  : solicitacao.codigo_despesa_receita,
              observacao: solicitacao.observacoes,
              data_emissao_nf: solicitacao.data_emissao_nf,
              informacoes_extra: solicitacao.informacoes_extra,
              codigo_conta:
                solicitacao.codigo_conta_interna === 0
                  ? ''
                  : solicitacao.codigo_conta_interna,
              codigo_centro_de_custo:
                solicitacao.codigo_centro_de_custo === 0
                  ? ''
                  : solicitacao.codigo_centro_de_custo,
              codigo_cartao:
                !solicitacao.codigo_cartao
                  ? ''
                  : solicitacao.codigo_cartao,
              mes_fatura: formatarMesFatura(solicitacao.mes_fatura),
            }
            : solicitacaoQueryString
              ? {
                ge: solicitacaoQueryString.ge,
                codigo_despesa_projeto_tipo_solicitacao:
                  solicitacaoQueryString.codigo_despesa_projeto_tipo_solicitacao,
                departamento: solicitacaoQueryString.codigo_departamento,
                tipo_documento: solicitacaoQueryString.codigo_tipo_documento,
                valor: solicitacaoQueryString.valor,
                tipo_pagamento: solicitacaoQueryString.codigo_tipo_pagamento,
                codigo_fornecedor:
                  solicitacaoQueryString.codigo_fornecedor === 0
                    ? ''
                    : solicitacaoQueryString.codigo_fornecedor,
                tem_rateio: solicitacaoQueryString.tem_rateio,
                data_vencimento: solicitacaoQueryString.data_vencimento,
                data_entrada: solicitacaoQueryString.data_entrada,
                numero_documento: solicitacaoQueryString.numero_documento || '',
                codigo_despesa_receita:
                  solicitacaoQueryString.codigo_despesa_receita === 0
                    ? ''
                    : solicitacaoQueryString.codigo_despesa_receita,
                observacao: solicitacaoQueryString.observacoes,
                data_emissao_nf: solicitacaoQueryString.data_emissao_nf,
                informacoes_extra: solicitacaoQueryString.informacoes_extra,
                codigo_conta:
                  solicitacaoQueryString.codigo_conta_interna === 0
                    ? ''
                    : solicitacaoQueryString.codigo_conta_interna,
                codigo_centro_de_custo:
                  solicitacaoQueryString.codigo_centro_de_custo === 0
                    ? ''
                    : solicitacaoQueryString.codigo_centro_de_custo,
                codigo_cartao:
                  !solicitacaoQueryString.codigo_cartao
                    ? ''
                    : solicitacaoQueryString.codigo_cartao,
                mes_fatura: formatarMesFatura(
                  solicitacaoQueryString.mes_fatura
                ),
              }
              : {
                ge: '',
                codigo_despesa_projeto_tipo_solicitacao: '',
                departamento: '',
                tipo_documento: '',
                valor: '',
                tipo_pagamento: '',
                codigo_fornecedor: '',
                tem_rateio: '',
                data_vencimento: '',
                data_entrada: new Date(),
                numero_documento: '',
                codigo_despesa_receita: '',
                observacao: '',
                data_emissao_nf: '',
                informacoes_extra: '',
                codigo_conta: '',
                codigo_centro_de_custo: '',
                codigo_cartao: '',
                mes_fatura: '',
              }
        }
        onSubmit={request => finalizarSolicitacao(request)}
        key={limparFormik}
      >
        {({ handleSubmit, setFieldValue, errors, values, touched }) => (
          <Form
            onSubmit={handleSubmit}
            className="container-fluid p-3 p-md-4"
            style={{ maxWidth: '1400px', margin: '0 auto' }}
          >
            <Card style={sectionStyles.card}>
              <div style={sectionStyles.cardHeader}>
                <FaBuilding />
                Identificação da Solicitação
              </div>
              <Card.Body style={sectionStyles.cardBody}>
                <Row>
                  <Col xs={12} md={6} lg={4}>
                    <Form.Group
                      controlId="codigo_despesa_projeto_tipo_solicitacao"
                      className="mb-3"
                    >
                      <Form.Label style={sectionStyles.formLabel}>
                        Tipo de Solicitação{' '}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Selector
                        isDisabled={
                          values.codigo_despesa_projeto_tipo_solicitacao !== ''
                        }
                        placeholder="Selecione o tipo..."
                        options={tipoSolicitacaoOptions}
                        value={
                          tipoSolicitacaoOptions.find(
                            option =>
                              option.value ==
                              values.codigo_despesa_projeto_tipo_solicitacao
                          ) || null
                        }
                        onChange={selectedOption => {
                          const value = selectedOption
                            ? selectedOption.value
                            : '';
                          verificarTipoFormulario(value);
                          setFieldValue(
                            'codigo_despesa_projeto_tipo_solicitacao',
                            value
                          );
                        }}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                      {errors.codigo_despesa_projeto_tipo_solicitacao && (
                        <div className="invalid-feedback d-block">
                          {errors.codigo_despesa_projeto_tipo_solicitacao}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} lg={4}>
                    <Form.Group controlId="ge" className="mb-3">
                      <Form.Label style={sectionStyles.formLabel}>
                        GE <span className="text-danger">*</span>
                      </Form.Label>
                      <Selector
                        isLoading={gesOptions.length === 0}
                        isDisabled={gesOptions.length === 0}
                        noOptionsMessage={() => 'Nenhum GE encontrado'}
                        placeholder="Buscar GE..."
                        options={gesOptions}
                        value={gesOptions.find(
                          option => option.value === values.ge
                        )}
                        onChange={(selectedOption) => {
                          const novoGe = selectedOption
                            ? selectedOption.value
                            : '';
                          setFieldValue('ge', novoGe);
                          setFieldValue('departamento', '');
                          setFieldValue('codigo_fornecedor', '');
                          setFieldValue('codigo_despesa_receita', '');
                          setFieldValue('codigo_cartao', '');
                          setTipoDocumentoSelecionado(null);
                          limparOptions();
                          if (novoGe !== '') {
                            obterFiltrosRestantes(
                              values.codigo_despesa_projeto_tipo_solicitacao,
                              novoGe
                            );
                            obterFornecedores(
                              novoGe,
                              values.codigo_despesa_projeto_tipo_solicitacao
                            );
                            if (tipoDespesaCartaoCreditoSelecionado) {
                              obterCartoesAtivos(novoGe);
                            }
                          }
                        }}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                      {errors.ge && (
                        <div className="invalid-feedback d-block">
                          {errors.ge}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={6} lg={4}>
                    <Form.Group controlId="departamento" className="mb-3">
                      <Form.Label style={sectionStyles.formLabel}>
                        Departamento <span className="text-danger">*</span>
                      </Form.Label>
                      <Selector
                        isLoading={departamentosOptions.length === 0}
                        isDisabled={
                          departamentosOptions.length === 0 || !values.ge
                        }
                        noOptionsMessage={() =>
                          'Nenhum departamento encontrado'
                        }
                        placeholder={
                          !values.ge
                            ? 'Selecione um GE primeiro'
                            : 'Buscar departamento...'
                        }
                        options={departamentosOptions}
                        value={
                          departamentosOptions.find(
                            option => option.value === values.departamento
                          ) || null
                        }
                        onChange={selectedOption => {
                          if (
                            !departamentoValido(
                              values.ge,
                              selectedOption.value,
                              values.codigo_despesa_projeto_tipo_solicitacao
                            )
                          ) {
                            return;
                          }
                          setFieldValue(
                            'departamento',
                            selectedOption ? selectedOption.value : ''
                          );
                        }}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                      />
                      {errors.departamento && (
                        <div className="invalid-feedback d-block">
                          {errors.departamento}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {tipoProjetoSelecionado && (
              <Card style={sectionStyles.card}>
                <div style={sectionStyles.cardHeader}>
                  <FaFolderOpen />
                  Dados do Projeto
                </div>
                <Card.Body style={sectionStyles.cardBody}>
                  <Row>
                    <Col xs={12} md={6}>
                      <Form.Group controlId="codigo_conta" className="mb-3">
                        <Form.Label style={sectionStyles.formLabel}>
                          Conta <span className="text-danger">*</span>
                        </Form.Label>
                        <Selector
                          isLoading={contasInternasOptions.length === 0}
                          isDisabled={
                            contasInternasOptions.length === 0 || !values.ge
                          }
                          noOptionsMessage={() => 'Nenhuma conta encontrada'}
                          placeholder={
                            !values.ge
                              ? 'Selecione um GE primeiro'
                              : 'Buscar conta...'
                          }
                          options={contasInternasOptions || []}
                          value={
                            contasInternasOptions.find(
                              option => option.value === values.codigo_conta
                            ) || null
                          }
                          onChange={selectedOption => {
                            if (
                              values.codigo_despesa_projeto_tipo_solicitacao === TIPOS_SOLICITACAO.Projeto &&
                              values.departamento &&
                              !contaProjetoValida(values.ge, selectedOption.value, values.departamento)
                            ) {
                              return;
                            }

                            setFieldValue(
                              'codigo_conta',
                              selectedOption ? selectedOption.value : ''
                            );
                            if (selectedOption.value !== '') {
                              obterFiltroCentralDeCustos(
                                values.ge,
                                selectedOption.value
                              );
                            }
                          }}
                          styles={customStyles}
                          components={{ DropdownIndicator }}
                        />
                        {errors.codigo_conta && (
                          <div className="invalid-feedback d-block">
                            {errors.codigo_conta}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6}>
                      <Form.Group
                        controlId="codigo_centro_de_custo"
                        className="mb-3"
                      >
                        <Form.Label style={sectionStyles.formLabel}>
                          Centro de Custo <span className="text-danger">*</span>
                        </Form.Label>
                        <Selector
                          isLoading={centroDeCustoOptions.length === 0}
                          isDisabled={
                            centroDeCustoOptions.length === 0 ||
                            !values.codigo_conta
                          }
                          placeholder={
                            !values.codigo_conta
                              ? 'Selecione uma conta primeiro'
                              : 'Buscar centro de custo...'
                          }
                          noOptionsMessage={() =>
                            'Nenhum centro de custo encontrado'
                          }
                          options={centroDeCustoOptions || []}
                          value={
                            centroDeCustoOptions.find(
                              option =>
                                option.value === values.codigo_centro_de_custo
                            ) || null
                          }
                          onChange={selectedOption => {
                            setFieldValue(
                              'codigo_centro_de_custo',
                              selectedOption ? selectedOption.value : ''
                            );
                          }}
                          styles={customStyles}
                          components={{ DropdownIndicator }}
                        />
                        {errors.codigo_centro_de_custo && (
                          <div className="invalid-feedback d-block">
                            {errors.codigo_centro_de_custo}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}

            {(tipoProjetoSelecionado ||
              tipoDespesaSelecionado ||
              tipoComissaoSelecionado) && (
                <Card style={sectionStyles.card}>
                  <div style={sectionStyles.cardHeader}>
                    <FaMoneyBillWave />
                    Valores e Documento
                  </div>
                  <Card.Body style={sectionStyles.cardBody}>
                    <Row>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <Form.Group controlId="valor" className="mb-3">
                          <Form.Label style={sectionStyles.formLabel}>
                            Valor <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            id="valor"
                            type="tel"
                            placeholder={formatarMonetario(1599.99)}
                            name="valor"
                            value={values.valor}
                            component={MoneyField}
                            className="form-control"
                          />
                          {errors.valor && (
                            <div className="invalid-feedback d-block">
                              {errors.valor}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <Form.Group controlId="numero_documento" className="mb-3">
                          <Form.Label style={sectionStyles.formLabel}>
                            N° Documento <span className="text-danger">*</span>
                          </Form.Label>
                          <Field
                            type="numeric"
                            name="numero_documento"
                            className="form-control"
                            placeholder="Digite o número"
                          />
                          {errors.numero_documento && (
                            <div className="invalid-feedback d-block">
                              {errors.numero_documento}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      {tipoDespesaCartaoCreditoSelecionado ? (
                        <>
                          <Col xs={12} sm={6} md={4} lg={3}>
                            <Form.Group controlId="codigo_cartao" className="mb-3">
                              <Form.Label style={sectionStyles.formLabel}>
                                Nº Cartão <span className="text-danger">*</span>
                              </Form.Label>
                              <Selector
                                isLoading={
                                  !!values.ge && cartoesOptions.length === 0
                                }
                                isDisabled={
                                  !values.ge || cartoesOptions.length === 0
                                }
                                noOptionsMessage={() =>
                                  'Nenhum cartão ativo encontrado'
                                }
                                placeholder={
                                  !values.ge
                                    ? 'Selecione um GE primeiro'
                                    : 'Selecione o cartão...'
                                }
                                options={cartoesOptions}
                                value={
                                  cartoesOptions.find(
                                    option =>
                                      option.value === values.codigo_cartao
                                  ) || null
                                }
                                onChange={selectedOption =>
                                  setFieldValue(
                                    'codigo_cartao',
                                    selectedOption ? selectedOption.value : ''
                                  )
                                }
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                              />
                              {errors.codigo_cartao && (
                                <div className="invalid-feedback d-block">
                                  {errors.codigo_cartao}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        </>
                      ) : (
                        <Col xs={12} sm={6} md={4} lg={3}>
                          <Form.Group controlId="tipo_pagamento" className="mb-3">
                            <Form.Label style={sectionStyles.formLabel}>
                              Tipo de Pagamento{' '}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Selector
                              isLoading={tiposPagamentoOptions.length === 0}
                              isDisabled={
                                tiposPagamentoOptions.length === 0 || !values.ge
                              }
                              noOptionsMessage={() => 'Nenhum tipo encontrado'}
                              placeholder="Selecione..."
                              options={tiposPagamentoOptions}
                              value={
                                tiposPagamentoOptions.find(
                                  option => option.value === values.tipo_pagamento
                                ) || null
                              }
                              onChange={selectedOption =>
                                setFieldValue(
                                  'tipo_pagamento',
                                  selectedOption ? selectedOption.value : ''
                                )
                              }
                              styles={customStyles}
                              components={{ DropdownIndicator }}
                            />
                            {errors.tipo_pagamento && (
                              <div className="invalid-feedback d-block">
                                {errors.tipo_pagamento}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <Form.Group controlId="tipo_documento" className="mb-3">
                          <Form.Label style={sectionStyles.formLabel}>
                            Tipo de Documento{' '}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Selector
                            isLoading={tiposDocOptions.length === 0}
                            isDisabled={
                              tiposDocOptions.length === 0 || !values.ge
                            }
                            noOptionsMessage={() => 'Nenhum tipo encontrado'}
                            placeholder="Selecione..."
                            options={tiposDocOptions}
                            value={
                              tiposDocOptions.find(
                                option => option.value === values.tipo_documento
                              ) || null
                            }
                            onChange={selectedOption => {
                              setFieldValue(
                                'tipo_documento',
                                selectedOption ? selectedOption.value : ''
                              );
                              setTipoDocumentoSelecionado(
                                selectedOption ? selectedOption.value : null
                              );
                            }}
                            styles={customStyles}
                            components={{ DropdownIndicator }}
                          />
                          {errors.tipo_documento && (
                            <div className="invalid-feedback d-block">
                              {errors.tipo_documento}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                      {(tipoDespesaSelecionado || tipoComissaoSelecionado) && (
                        <>
                          <Col xs={12} sm={6} md={4} lg={3}>
                            <Form.Group
                              controlId="codigo_despesa_receita"
                              className="mb-3"
                            >
                              <Form.Label style={sectionStyles.formLabel}>
                                {tipoDespesaSelecionado
                                  ? 'Despesa/Receita'
                                  : 'Conta Corretor'}{' '}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Selector
                                isLoading={despesaReceitaOptions.length === 0}
                                isDisabled={
                                  despesaReceitaOptions.length === 0 || !values.ge
                                }
                                noOptionsMessage={() => 'Nenhum tipo encontrado'}
                                placeholder="Selecione..."
                                options={despesaReceitaOptions}
                                value={
                                  despesaReceitaOptions.find(
                                    option =>
                                      option.value ===
                                      values.codigo_despesa_receita
                                  ) || null
                                }
                                onChange={selectedOption => {
                                  if (
                                    !despesaValida(
                                      values.ge,
                                      selectedOption.value,
                                      selectedOption.tipo
                                    )
                                  ) {
                                    return;
                                  }
                                  setFieldValue(
                                    'codigo_despesa_receita',
                                    selectedOption ? selectedOption.value : ''
                                  );
                                }}
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                              />
                              {errors.codigo_despesa_receita && (
                                <div className="invalid-feedback d-block">
                                  {errors.codigo_despesa_receita}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          <Col xs={12} sm={6} md={4} lg={3}>
                            <Form.Group controlId="tem_rateio" className="mb-3">
                              <Form.Label style={sectionStyles.formLabel}>
                                Tem Rateio?
                              </Form.Label>
                              <Selector
                                placeholder="Selecione..."
                                options={temRateioOptions}
                                value={
                                  temRateioOptions.find(
                                    option =>
                                      option.value === String(values.tem_rateio)
                                  ) || null
                                }
                                onChange={selectedOption => {
                                  if (
                                    !rateioValido(values.ge, selectedOption.value)
                                  ) {
                                    return;
                                  }

                                  setFieldValue(
                                    'tem_rateio',
                                    selectedOption ? selectedOption.value : ''
                                  );
                                }}
                                styles={customStyles}
                                components={{ DropdownIndicator }}
                              />
                            </Form.Group>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              )}

            {(tipoProjetoSelecionado ||
              tipoDespesaSelecionado ||
              tipoComissaoSelecionado) && (
                <Card style={sectionStyles.card}>
                  <div style={sectionStyles.cardHeader}>
                    <FaCalendarAlt />
                    Datas
                  </div>
                  <Card.Body style={sectionStyles.cardBody}>
                    <Row>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <DateMask
                          initialValue={values.data_entrada}
                          onValidate={value =>
                            setFieldValue('data_entrada', value)
                          }
                          restrictToSqlMinDate
                          allowPast
                        >
                          {({ dateError, dateValue, setDate }) => (
                            <Form.Group
                              controlId="values.data_entrada"
                              className="mb-3"
                            >
                              <Form.Label style={sectionStyles.formLabel}>
                                Data de Entrada{' '}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <MaskedInput
                                name="data_entrada"
                                type="tel"
                                guide={false}
                                className={`form-control ${((errors.data_entrada &&
                                  touched.data_entrada) ||
                                  dateError) &&
                                  'is-invalid'
                                  }`}
                                placeholder="DD/MM/AAAA"
                                mask={MASK_DATE}
                                value={dateValue}
                                onChange={e => setDate(e.target.value)}
                              />
                              {(errors.data_entrada || dateError) && (
                                <div className="invalid-feedback d-block">
                                  {errors.data_entrada || dateError}
                                </div>
                              )}
                            </Form.Group>
                          )}
                        </DateMask>
                      </Col>
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <DateMask
                          initialValue={values.data_vencimento}
                          onValidate={value =>
                            setFieldValue('data_vencimento', value)
                          }
                          restrictToSqlMinDate
                          allowPast
                          allowFuture
                        >
                          {({ dateError, dateValue, setDate }) => (
                            <Form.Group
                              controlId="values.data_vencimento"
                              className="mb-3"
                            >
                              <Form.Label style={sectionStyles.formLabel}>
                                {tipoDespesaCartaoCreditoSelecionado
                                  ? 'Data da Compra'
                                  : 'Data de Vencimento'}{' '}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <MaskedInput
                                name="data_vencimento"
                                type="tel"
                                guide={false}
                                className={`form-control ${((errors.data_vencimento &&
                                  touched.data_vencimento) ||
                                  dateError) &&
                                  'is-invalid'
                                  }`}
                                placeholder="DD/MM/AAAA"
                                mask={MASK_DATE}
                                value={dateValue}
                                onChange={e => setDate(e.target.value)}
                              />
                              {(errors.data_vencimento || dateError) && (
                                <div className="invalid-feedback d-block">
                                  {errors.data_vencimento || dateError}
                                </div>
                              )}
                            </Form.Group>
                          )}
                        </DateMask>
                      </Col>
                      {tipoDespesaCartaoCreditoSelecionado && (
                        <Col xs={12} sm={6} md={4} lg={3}>
                          <Form.Group controlId="mes_fatura" className="mb-3">
                            <Form.Label style={sectionStyles.formLabel}>
                              Mês Fatura <span className="text-danger">*</span>
                            </Form.Label>
                            <MaskedInput
                              name="mes_fatura"
                              type="tel"
                              guide={false}
                              className={`form-control ${errors.mes_fatura && touched.mes_fatura
                                ? 'is-invalid'
                                : ''
                                }`}
                              placeholder="MM/AAAA"
                              mask={MASK_MES_ANO}
                              value={values.mes_fatura}
                              onChange={e =>
                                setFieldValue('mes_fatura', e.target.value)
                              }
                            />
                            {errors.mes_fatura && (
                              <div className="invalid-feedback d-block">
                                {errors.mes_fatura}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      )}
                      {habilitarCampoDataNF(values.tipo_documento) && (
                        <Col xs={12} sm={6} md={4} lg={3}>
                          <DateMask
                            initialValue={values.data_emissao_nf}
                            onValidate={value =>
                              setFieldValue('data_emissao_nf', value)
                            }
                            restrictToSqlMinDate
                            allowPast
                          >
                            {({ dateError, dateValue, setDate }) => (
                              <Form.Group
                                controlId="values.data_emissao_nf"
                                className="mb-3"
                              >
                                <Form.Label style={sectionStyles.formLabel}>
                                  Data Emissão NF
                                </Form.Label>
                                <MaskedInput
                                  name="data_emissao_nf"
                                  type="tel"
                                  guide={false}
                                  className={`form-control ${((errors.data_emissao_nf &&
                                    touched.data_emissao_nf) ||
                                    dateError) &&
                                    'is-invalid'
                                    }`}
                                  placeholder="DD/MM/AAAA"
                                  mask={MASK_DATE}
                                  value={dateValue}
                                  onChange={e => setDate(e.target.value)}
                                />
                                {(errors.data_emissao_nf || dateError) && (
                                  <div className="invalid-feedback d-block">
                                    {errors.data_emissao_nf || dateError}
                                  </div>
                                )}
                              </Form.Group>
                            )}
                          </DateMask>
                        </Col>
                      )}
                    </Row>
                  </Card.Body>
                </Card>
              )}

            {(tipoProjetoSelecionado ||
              tipoDespesaSelecionado ||
              tipoComissaoSelecionado) && (
                <Card style={sectionStyles.card}>
                  <div style={sectionStyles.cardHeader}>
                    <FaUserTie />
                    Fornecedor
                  </div>
                  <Card.Body style={sectionStyles.cardBody}>
                    <Row>
                      <Col xs={12}>
                        <Form.Group
                          controlId="codigo_fornecedor"
                          className="mb-3"
                        >
                          <Form.Label style={sectionStyles.formLabel}>
                            Fornecedor
                          </Form.Label>
                          {tipoDespesaSelecionado || tipoComissaoSelecionado ? (
                            <Selector
                              isLoading={fornecedoresOptions.length === 0}
                              isDisabled={
                                fornecedoresOptions.length === 0 || !values.ge
                              }
                              noOptionsMessage={() =>
                                'Nenhum fornecedor encontrado'
                              }
                              placeholder={
                                !values.ge
                                  ? 'Selecione um GE primeiro'
                                  : 'Buscar fornecedor...'
                              }
                              options={fornecedoresOptions}
                              value={
                                fornecedoresOptions.find(
                                  option =>
                                    option.value === values.codigo_fornecedor
                                ) || null
                              }
                              onChange={selectedOption =>
                                setFieldValue(
                                  'codigo_fornecedor',
                                  selectedOption ? selectedOption.value : ''
                                )
                              }
                              styles={customStyles}
                              components={{ DropdownIndicator }}
                            />
                          ) : (
                            <Selector
                              isLoading={
                                fornecedoresTipoProjetoOptions.length === 0
                              }
                              isDisabled={
                                fornecedoresTipoProjetoOptions.length === 0 ||
                                !values.ge
                              }
                              noOptionsMessage={() =>
                                'Nenhum fornecedor encontrado'
                              }
                              placeholder={
                                !values.ge
                                  ? 'Selecione um GE primeiro'
                                  : 'Buscar fornecedor...'
                              }
                              options={fornecedoresTipoProjetoOptions}
                              value={
                                fornecedoresTipoProjetoOptions.find(
                                  option =>
                                    option.value === values.codigo_fornecedor
                                ) || null
                              }
                              onChange={selectedOption =>
                                setFieldValue(
                                  'codigo_fornecedor',
                                  selectedOption ? selectedOption.value : ''
                                )
                              }
                              styles={customStyles}
                              components={{ DropdownIndicator }}
                            />
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}

            {(tipoDespesaSelecionado ||
              tipoProjetoSelecionado ||
              tipoComissaoSelecionado) && (
                <Card style={sectionStyles.card}>
                  <div style={sectionStyles.cardHeader}>
                    <FaClipboardList />
                    Observações
                  </div>
                  <Card.Body style={sectionStyles.cardBody}>
                    <Row>
                      <Col xs={12} md={6}>
                        <Form.Group controlId="observacao" className="mb-3">
                          <Form.Label style={sectionStyles.formLabel}>
                            Observação
                          </Form.Label>
                          <textarea
                            name="observacao"
                            className="form-control"
                            value={values.observacao}
                            onChange={e =>
                              setFieldValue('observacao', e.target.value)
                            }
                            rows={4}
                            maxLength={200}
                            placeholder="Digite uma observação (máx. 200 caracteres)"
                            style={{ resize: 'none' }}
                          />
                          <small className="text-muted">
                            {values.observacao?.length || 0}/200 caracteres
                          </small>
                        </Form.Group>
                      </Col>
                      <Col xs={12} md={6}>
                        <Form.Group
                          controlId="informacoes_extra"
                          className="mb-3"
                        >
                          <Form.Label style={sectionStyles.formLabel}>
                            Informações Extras
                          </Form.Label>
                          <textarea
                            name="informacoes_extra"
                            className="form-control"
                            value={values.informacoes_extra}
                            onChange={e =>
                              setFieldValue('informacoes_extra', e.target.value)
                            }
                            rows={4}
                            placeholder="Digite informações adicionais"
                            style={{ resize: 'none' }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            <Card style={sectionStyles.card}>
              <div style={sectionStyles.cardHeader}>
                <FaFileAlt />
                Arquivos e Digitalizações
              </div>
              <Card.Body style={sectionStyles.cardBody}>
                <Row>
                  <Col xs={12} lg={6}>
                    <div
                      className="border rounded p-4 text-center mb-3 mb-lg-0"
                      style={{
                        borderStyle: 'dashed',
                        backgroundColor: '#f8f9fc',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                      }}
                      onClick={() => {
                        arquivoRef.current.value = '';
                        arquivoRef.current.click();
                      }}
                      onMouseOver={e =>
                        (e.currentTarget.style.backgroundColor = '#eaecf4')
                      }
                      onMouseOut={e =>
                        (e.currentTarget.style.backgroundColor = '#f8f9fc')
                      }
                    >
                      <FaFileUpload
                        style={{
                          fontSize: '2.5rem',
                          marginBottom: '0.75rem',
                        }}
                      />
                      <p
                        className="mb-1"
                        style={{ fontWeight: '500', color: '#5a5c69' }}
                      >
                        Clique para selecionar arquivos
                      </p>
                    </div>
                    <input
                      type="file"
                      className="d-none"
                      name="UploadArquivo"
                      id="UploadArquivo"
                      ref={arquivoRef}
                      multiple
                      onChange={e => adicionarArquivos(e)}
                    />
                  </Col>
                  <Col xs={12} lg={6}>
                    <div
                      style={{
                        maxHeight: '200px',
                        overflowY: 'auto',
                        border: '1px solid #e3e6f0',
                        borderRadius: '0.375rem',
                      }}
                    >
                      <Table
                        size="sm"
                        hover
                        className="mb-0"
                        style={{ fontSize: '0.875rem' }}
                      >
                        <thead
                          style={{
                            backgroundColor: '#f8f9fc',
                            position: 'sticky',
                            top: 0,
                          }}
                        >
                          <tr>
                            <th
                              style={{
                                fontWeight: '600',
                                color: '#5a5c69',
                                padding: '0.75rem',
                              }}
                            >
                              Arquivos Selecionados ({arquivosParaEnvio.length})
                            </th>
                            <th style={{ width: '50px' }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {arquivosParaEnvio.length > 0 ? (
                            arquivosParaEnvio.map((digitalizacao, index) => (
                              <tr key={index}>
                                <td
                                  className="align-middle"
                                  style={{ padding: '0.5rem 0.75rem' }}
                                >
                                  <FaFileAlt
                                    className="mr-2"
                                    style={{ color: '#6f42c1' }}
                                  />
                                  {digitalizacao.name}
                                </td>
                                <td className="text-center align-middle">
                                  <Button
                                    variant="link"
                                    size="sm"
                                    className="p-0 text-danger"
                                    title="Remover arquivo"
                                    onClick={() =>
                                      removerDigitalizacao(digitalizacao)
                                    }
                                  >
                                    <FaTrash />
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan={2}
                                className="text-center text-muted py-4"
                              >
                                Nenhum arquivo selecionado
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <div
              className="d-flex flex-column flex-sm-row justify-content-end pt-2 pb-4"
              style={{ gap: '0.75rem' }}
            >
              <Button
                disabled={
                  salvandoSolicitacao || solicitacao || solicitacaoQueryString
                }
                variant="outline-danger"
                onClick={() => limparFormulario()}
                className="px-4"
                style={{ minWidth: '140px' }}
              >
                <FaEraser className="mr-2" />
                Limpar
              </Button>
              <Button
                disabled={
                  values.codigo_despesa_projeto_tipo_solicitacao === '' ||
                  Object.values(errors).length > 0 ||
                  salvandoSolicitacao ||
                  arquivosParaEnvio.length === 0
                }
                variant="success"
                type="submit"
                className="px-4"
                style={{ minWidth: '140px' }}
              >
                {salvandoSolicitacao ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                    />
                    Salvando...
                  </>
                ) : (
                  <>
                    <FaCloudUploadAlt className="mr-2" />
                    {solicitacao ? 'Atualizar' : 'Salvar'}
                  </>
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
      <Modal
        show={mostrarModalContaInvalida || mostrarModalDepartamentoInvalido}
        onHide={() => {
          setMostrarModalContaInvalida(false);
          setMostrarModalDepartamentoInvalido(false);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center">
            Atenção
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div className="d-flex justify-content-center align-items-center mb-3">
            <FaExclamationTriangle size={32} />
          </div>
          <h5>
            {mostrarModalDepartamentoInvalido
              ? 'Departamento inválido'
              : 'Conta de despesa/receita inválida'}
          </h5>
          <p className=" text-left text-muted mb-0 mt-2">
            Sistema participa de parceria em loteamento, este lançamento não está autorizado!
            Abrir chamado para Controladoria através do <a href="https://suporte.setpar.com.br" target="_blank" rel="noopener noreferrer">GLPI</a>, especificando o lançamento que deseja efetuar.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0">
          <Button
            variant="warning"
            onClick={() => {
              setMostrarModalContaInvalida(false);
              setMostrarModalDepartamentoInvalido(false);
            }}
            style={{ minWidth: '120px' }}
          >
            Entendi
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={mostrarModalRateioInvalido}
        onHide={() => {
          setMostrarModalRateioInvalido(false);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center">
            Atenção
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center py-4">
          <div className="d-flex justify-content-center align-items-center mb-3">
            <FaExclamationTriangle size={32} />
          </div>
          <h5>Rateio não permitido</h5>
          <p className=" text-left text-muted mb-0 mt-2">
            Sistema participa de parceria em loteamento, lançamento com rateio
            não está autorizado! Consulte a controladoria!
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0">
          <Button
            variant="warning"
            onClick={() => {
              setMostrarModalRateioInvalido(false);
            }}
            style={{ minWidth: '120px' }}
          >
            Entendi
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
